import { KVKK_AYDINLATMA_METNI } from "../data/kvkk-aydinlatma"
import { YasalBelgeSayfasi } from "./yasal-belge-sayfasi"

export function KvkkSayfasi() {
  return <YasalBelgeSayfasi belge={KVKK_AYDINLATMA_METNI} />
}
